
import { useState } from "react";

/**
 * Hook for managing Slack connection state
 */
export const useSlackConnectionState = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [connectionError, setConnectionError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);

  return {
    isConnected,
    setIsConnected,
    connectionError,
    setConnectionError,
    isLoading,
    setIsLoading,
    isChecking,
    setIsChecking,
    isInitialized,
    setIsInitialized
  };
};
